import React, { useState } from 'react';
import { CanvasView } from './CanvasView';
import { DocumentBrowser } from './DocumentBrowser';

const TABS = [
  { id: 'canvas',    label: 'Canvas'    },
  { id: 'documents', label: 'Documents' },
] as const;

type StrategyTab = typeof TABS[number]['id'];

export const StrategyView: React.FC = () => {
  const [active, setActive] = useState<StrategyTab>('canvas');
  const isCanvas = active === 'canvas';

  return (
    <div className="flex flex-col h-full min-h-0">
      {/* Tab bar */}
      <div
        className="flex-shrink-0 flex gap-1 px-1 pt-1 pb-0"
        style={{ borderBottom: '1px solid var(--border-subtle)' }}
      >
        {TABS.map(tab => {
          const isActive = active === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActive(tab.id)}
              className="px-4 py-2 text-sm font-medium transition-colors focus-visible:outline-none"
              style={{
                fontFamily: 'var(--font-ui)',
                color: isActive ? 'var(--accent-amber)' : 'var(--text-secondary)',
                borderBottom: isActive ? '2px solid var(--accent-amber)' : '2px solid transparent',
                backgroundColor: 'transparent',
                marginBottom: '-1px',
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Canvas needs overflow-hidden for its internal grid; Documents needs overflow-auto */}
      <div className={`flex-1 min-h-0 ${isCanvas ? 'overflow-hidden' : 'overflow-auto'}`}>
        {active === 'canvas'    && <CanvasView />}
        {active === 'documents' && <DocumentBrowser />}
      </div>
    </div>
  );
};
